import React, { useState } from "react";
import InfoIcon from '@mui/icons-material/Info';
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { ManagePageForm } from './ManagePageForm'
export interface ManagePageCatalogProps {
    id: string
}

export default function ManagePageCatalog({
    id
}: ManagePageCatalogProps) {
    const [open, setOpen] = useState(false)
    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    //handle form submit api here
    return (
        <div>
            <Button variant='filled' size='small' onClick={handleClickOpen}>
                <InfoIcon />
            </Button>
            <BootstrapDialog
                fullWidth
                maxWidth='lg'
                onClose={handleClose}
                aria-labelledby='customized-dialog-title'
                open={open}
            >
                <BootstrapDialogTitle onClose={handleClose}>
                    Manage Page Catalogs
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <ManagePageForm pageId={id} handleClose={handleClose} />
                </DialogContent>
            </BootstrapDialog>
        </div>
    )
}
